<template>
    <div>
        <v-timeline dense>
            <v-timeline-item
                v-for="(step, i) in booking.histories"
                :key="i"
                small
                color="primary"
            >
                <div class="timeline-label">{{ getLabel(step) }}</div>
                <div class="timeline-date">{{ parseDate(step.created_at, 'DD/MM/YYYY HH:mm') }}</div>
            </v-timeline-item>
        </v-timeline>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "StatusReserve",
    props: {
        booking: Object,
    },
    methods: {
        parseDate(date, format) {
            return moment(date).format(format);
        },
        getLabel(step) {
            const status = {
                bookingCreated: "Reserva criada",
                vcnCreated: "Cartão criado",
                bookingConfirmed: `Reserva confirmada por: ${this.booking.finalized_by}-${this.booking.emitted_by_operator ? 'Onfly' : 'Hotel'}`,
                bookingCanceled: `Reserva cancelada por: ${this.booking.finalized_by}-${this.booking.emitted_by_operator ? 'Onfly' : 'Hotel'}`,
                vcnCanceled: `Cartão cancelado por: ${step.creator}`,
                bookingSent: "Email de solicitação enviado",
                invoiceReminderSent: "Nota fiscal solicitada",
                invoiceAttached: "Nota fiscal anexada",
                integratedWithErp: "Integrada com ERP",
                paymentDetailsSent: "Email de pagamento enviado",
                vcnRecharged: "Cartão carregado",
                vcnUnblocked: "Cartão desbloqueado",
                bookingPixPaid: `Reserva marcada como paga por: ${step.creator}`,
                messageSent: "WhatsApp enviado",
                cancellationSent: "Email de cancelamento enviado",
                cardVisualized: `Cartão visualizado por: ${step.creator}`,
                pixPaymentSent: "Pagamento pix agendado",
                pixPaymentError: "Erro no pagamento pix",
                pixErrorSent: "Email de erro no pix enviado",
                changedPixKey: `Chave pix alterada por: ${step.creator}`,
                bookingTotalValueChanged: `Valor da reserva alterada por :${step.creator}`,
                pixKeyNonExistent: 'Erro no pagamento pix: Chave PIX não encontrada',
                blueVcnCreated: 'Cartão virtual criado pelo Blue',
                bee2PayVcnCreated: 'Cartão virtual criado pela Bee2Pay',
                bookingUnanswered: `Reserva marcada como não respondida por: ${step.creator}`,
                bookingUnpaid: `Reserva marcada como não paga por: ${step.creator}`,
                pendingReminderEmailSent: 'Email de lembrete enviado',
                pendingReminderMessageSent: 'WhatsApp de lembrete enviado'
            }
            return status[step.status];
        },
    }
}

</script>

<style lang="scss" scoped>
.timeline-label {
    font-size: 0.875rem;
    font-weight: 500;
}

.timeline-date {
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.6);
}
</style>
